import { render, staticRenderFns } from "./LaVenenta.vue?vue&type=template&id=c9fcaef2"
import script from "./LaVenenta.vue?vue&type=script&lang=js"
export * from "./LaVenenta.vue?vue&type=script&lang=js"
import style0 from "./LaVenenta.vue?vue&type=style&index=0&id=c9fcaef2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports